export const checkForOnlyWhiteSpace = (str) => {
  return !str.replace(/\s/g, '').length
} 